<template>
  <div :style="{ flex: flex_computed }" class="cnd-dialog cube-dialog">
    <slot />
  </div>
</template>

<script>
import '../../../../lib/styles/components/AutoWrap.scss'

export default {
  name: 'AutoWrap',
  props: {
    // 分配比例
    flex: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {}
  },
  computed: {
    flex_computed() {
      return Number(this.flex)
    }
  }
}
</script>
